var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.windowWidth >= 600)?_c('ConnectFeaturesDesktop',{attrs:{"animation-enabled":_vm.animationEnabled}}):_c('ConnectFeaturesMobile',{attrs:{"animation-enabled":_vm.animationEnabled}})}
var staticRenderFns = []

export { render, staticRenderFns }